import React from "react";
import RoleItem from "./RoleItem";

const RolesSetup = ({ handlePermissions, permissions, disabled }) => {
    let arr = [];

    const handleItemChange = (checked, newItem) => {
        const type = newItem.split('.');
        if (checked) {
            const index = arr.indexOf(newItem);
            if (index > -1) {
                arr.splice(index, 1);
            }
            if (type[1] === 'All') {
                arr.push(`${type[0]}.View`);
                arr.push(`${type[0]}.Edit`);
                if (type[0] !== "Account") {
                    arr.push(`${type[0]}.Create`);
                    arr.push(`${type[0]}.Delete`);
                }
            } else {
                arr.push(newItem);
            }
            handlePermissions(true, arr);
        } else {
            if (type[1] === 'All') {
                const indexView = arr.indexOf(`${type[0]}.View`);
                const indexEdit = arr.indexOf(`${type[0]}.Edit`);
                const indexCreate = arr.indexOf(`${type[0]}.Create`);
                const indexDelete = arr.indexOf(`${type[0]}.Delete`);
                if (indexView > -1) {
                    arr.splice(indexView, 1);
                }
                arr.push(`${type[0]}.View`);
                if (indexEdit > -1) {
                    arr.splice(indexEdit, 1);
                }
                arr.push(`${type[0]}.Edit`);
                if (indexCreate > -1) {
                    arr.splice(indexCreate, 1);
                }
                arr.push(`${type[0]}.Create`);
                if (indexDelete > -1) {
                    arr.splice(indexDelete, 1);
                }
                arr.push(`${type[0]}.Delete`);
            } else {
                if (arr.includes(newItem)) {
                    const index = arr.indexOf(newItem);
                    if (index > -1) {
                        arr.splice(index, 1);
                    }
                }
                arr.push(newItem);
            }
            handlePermissions(false, arr);
        }
    };

    const jsonData = [
        // { displayTitle: 'Account', title: 'Account', permission: ['All', 'View', 'Edit'] },
        // { displayTitle: 'Resources', title: 'User', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        // { displayTitle: 'Roles', title: 'Role', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Clients', title: 'Client', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Portfolios', title: 'Portfolio', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Programs', title: 'Program', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Projects', title: 'Project', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Scopes / Milestones', title: 'Scope', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Tasks', title: 'Task', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Change Requests', title: 'ChangeRequest', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Risks', title: 'Risk', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Meetings', title: 'Meeting', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Communication Plans', title: 'CommunicationPlan', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Budgets', title: 'CostItem', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Shifts', title: 'Shift', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Leaves', title: 'Leave', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Purchase Orders', title: 'PurchaseOrder', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] },
        { displayTitle: 'Invoice Registry', title: 'InvoiceEntry', permission: ['All', 'View', 'Edit', 'Delete', 'Create'] }
    ];

    const filteredData = jsonData.map(item => {
        const title = item.title;

        const filteredPermissions = item.permission.filter(permission => {
            return permissions.includes(`${title}.${permission}`);
        });
        return { ...item, permissions: filteredPermissions };
    });

    return (
        <table className="permissionModal">
            <thead>
                <tr>
                    <th scope="col">Roles</th>
                    <th scope="col">All</th>
                    <th scope="col">View</th>
                    <th scope="col">Edit</th>
                    <th scope="col">Create</th>
                    <th scope="col">Delete</th>
                </tr>
            </thead>
            <tbody>
                {filteredData.map((role, index) => (
                    <RoleItem
                        role={role}
                        key={index}
                        index={index}
                        disabled={disabled}
                        handleItemChange={handleItemChange}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default RolesSetup;